import { neutrals } from '../../../theme/colors';
import React from 'react';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useResponsiveScale } from '../../../contexts/ResponsiveScaleContext';

type FramePreviewBackgroundProps = {
  viewBox: { width: number; height: number; x: number; y: number };
  zIndex: number;
};

export const FramePreviewBackground = ({ viewBox, zIndex }: FramePreviewBackgroundProps) => {
  const { responsiveScaleSV, responsiveScale } = useResponsiveScale();

  const animatedStyle = useAnimatedStyle(() => ({
    width: viewBox.width * responsiveScaleSV.value,
    height: viewBox.height * responsiveScaleSV.value,
    top: viewBox.y * responsiveScaleSV.value,
    left: viewBox.x * responsiveScaleSV.value,
    zIndex,
    pointerEvents: 'none',
    position: 'absolute',
    backgroundColor: neutrals.white,
  }), [responsiveScaleSV, viewBox.width, viewBox.height, viewBox.x, viewBox.y, zIndex, responsiveScale]);

  return <Animated.View style={animatedStyle} />;
};
